var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "41",
      "height": "80"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill": "#FFE86C",
      "fill-rule": "evenodd",
      "d": "M35.004 34.99C32.07 37.924 21.78 45.882 21.78 55.094v3.847c0 3.908 3.255 6.478 4.152 7.374a7.62 7.62 0 0 1 2.255 5.433 7.685 7.685 0 0 1-7.688 7.687 7.685 7.685 0 0 1-7.688-7.687 7.66 7.66 0 0 1 2.243-5.433c.91-.896 4.164-3.466 4.164-7.374v-3.847c0-9.212-10.289-17.17-13.223-20.104A20.43 20.43 0 0 1 0 20.5C0 9.172 9.16.012 20.5 0 31.84.013 41 9.173 41 20.5a20.43 20.43 0 0 1-5.996 14.49"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }